export default __webpack_public_path__ + "static/media/snack-2.57d84ac5.jpg";